import { Maximize, Minimize } from '@music-vine/cadence/icons';
import { memo, useCallback, useEffect, useState } from 'react';
import { Button } from '@music-vine/cadence/ui';
interface FullscreenButtonProps {
  onClick: () => void;
}
const FullscreenButton = memo(({
  onClick
}: FullscreenButtonProps) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const handleFullscreenChange = useCallback(() => {
    setIsFullscreen(!!document.fullscreenElement);
  }, []);
  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, [handleFullscreenChange]);
  return <Button aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'} className="text-white enabled:hover:bg-transparent" data-testid="video-fullscreen-button" onClick={onClick} size="icon" variant="transparent">
      {isFullscreen ? <Minimize className="h-4 w-4" strokeWidth={2.5} /> : <Maximize className="h-4 w-4" strokeWidth={2.5} />}
    </Button>;
});
FullscreenButton.displayName = 'FullscreenButton';
export default FullscreenButton;